module.exports = __webpack_public_path__ + "img/email.1aa3223e.svg";